import type { AnyStrapiClient } from '@blockworks/platform/api/strapi';
import { makeStrapiQueries } from '@blockworks/platform/api/strapi/queries';

import { getAssetLogo } from '@/utils/logos';

export const createDashboardQueries = (client: AnyStrapiClient) => {
    const { getAnalyticsPage, getDashboardGroups } = makeStrapiQueries({ client, getAssetLogo });

    return {
        getAnalyticsPage,
        getDashboardGroups,
    };
};
